import React from 'react';
import { useMetaPixel } from './hooks/useMetaPixel';
import { TrustBar } from './components/TrustBar';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ForWho } from './components/ForWho';
import { MethodOverview } from './components/MethodOverview';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Comparison } from './components/Comparison';
import { Pricing } from './components/Pricing';
import { KitUpsell } from './components/KitUpsell';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
import { StickyCta } from './components/StickyCta';
import { PurchasePopup } from './components/PurchasePopup';
interface AppProps {
  /** Horas que dura la cuenta regresiva de lanzamiento */
  horasDeLanzamiento?: number;
  /** Porcentaje de cupos ya tomados */
  cuposTomados?: number;
  /** Barra de compra fija en móvil */
  barraDeCompraMovil?: boolean;
  /** Avisos de "compra verificada" cada 40-60 segundos */
  popupDeCompras?: boolean;
  /** ID del Meta Pixel (evento PageView) */
  metaPixelId?: string;
}
export function App({
  horasDeLanzamiento = 3,
  cuposTomados = 68,
  barraDeCompraMovil = true,
  popupDeCompras = true,
  metaPixelId = '950420514112134'
}: AppProps) {
  useMetaPixel(metaPixelId);
  return <div className="w-full overflow-x-hidden bg-cream-50 pb-16 font-sans md:pb-0" data-id="element-0" data-mp="33nq73vwxp979">
      <TrustBar data-id="element-1" data-mp="38l8hlqqlnwhd" />
      <Hero data-id="element-2" data-mp="38kqafz2efxuo" />
      <Testimonials data-id="element-3" data-mp="38k6u2msedhir" />
      <main data-id="element-4" data-mp="38nuqbtp88i16">
        <PainPoints data-id="element-5" data-mp="38o4ct7b2c724" />
        <ForWho data-id="element-6" data-mp="3dle2mo2d6kqh" />
        <MethodOverview data-id="element-7" data-mp="3dlw6o6v9q38y" />
        <Tomos data-id="element-8" data-mp="3dmfn1j59sjkv" />
        <Bonos data-id="element-9" data-mp="3dirvuqnas99b" />
        <Comparison data-id="element-10" data-mp="nvj2rdpwcaoo" />
        <Pricing durationHours={horasDeLanzamiento} cuposTomados={cuposTomados} data-id="element-11" data-mp="nw2c461hdqr3" />
        <KitUpsell data-id="element-12" data-mp="sudksdg1hv7q" />
        <Guarantee data-id="element-13" data-mp="stuexv3nyxa2" />
        <Faq data-id="element-14" data-mp="stc7e2bjwwmu" />
        <FinalCta durationHours={horasDeLanzamiento} data-id="element-15" data-mp="ssspumptca9c" />
      </main>
      <SiteFooter data-id="element-16" data-mp="35ovimiemwr0" />
      {barraDeCompraMovil ? <StickyCta durationHours={horasDeLanzamiento} data-id="element-17" data-mp="38kwkjpju1jo" /> : null}
      {popupDeCompras ? <PurchasePopup data-id="element-18" data-mp="3uc9jtyh2rqkc" /> : null}
    </div>;
}